import { render, staticRenderFns } from "./UrlParameters.vue?vue&type=template&id=cb97b280"
import script from "./UrlParameters.vue?vue&type=script&lang=js"
export * from "./UrlParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports